import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';

import ButtonOriginal from '../../../Button/Button';
import ConfirmationCodeInputOriginal from '../../../ConfirmationCodeInput/ConfirmationCodeInput';

export const ConfirmationCodeForm = styled.div``;

export const Heading = styled.p`
  ${fontBody(16)};
  color: var(--foreground);
  padding: 0;
  margin: 0 auto 16px auto;
  text-align: center;
  max-width: 279px;
`;

export const Emphasis = styled.span`
  ${fontTitle(16)};
  color: var(--foreground);
`;

export const ConfirmationCodeInput = styled(ConfirmationCodeInputOriginal)`
  margin-bottom: 16px;
`;

export const RequestButton = styled.button`
  border: 0;
  padding: 0;
  background: none;
  text-decoration: underline;
`;

export const Button = styled(ButtonOriginal)`
  &:not(:first-child) {
    margin-top: 16px;
  }
`;
